import React from 'react';

import { Route, RouteComponentProps, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const Communication = lazyWithRetry(() => import('./Communication'));

const CommunicationRoutes: React.FC<RouteComponentProps> = (props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="communication">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <Communication />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default CommunicationRoutes;
